import { getItem } from 'common/api/systems';

import {
    FETCH_ITEM,
    FETCH_ITEM_FAILURE,
    FETCH_ITEM_SUCCESS,
} from '../actionTypes';
import { actions } from '../reducer';

import prepareUpdate from './prepareUpdate';

export default (id) => (dispatch) =>
    new Promise((resolve) => {
        dispatch(actions[FETCH_ITEM]());

        getItem(id)
            .then((response) => {
                dispatch(actions[FETCH_ITEM_SUCCESS](response.data));
                dispatch(prepareUpdate(response.data));
            })
            .catch((error) => {
                dispatch(actions[FETCH_ITEM_FAILURE](error));
            })
            .finally(resolve);
    });
